/**
 * 
 * Shader combines the cut and twist filters.
 * It cuts the vector data (displacement either horizontal or vertical)
 * Then adds a subtle curve or warp to the cut.
 *
 */

import fragment from './silohuetteColor.glsl';

var SilohuetteColor = function (color) {

    PIXI.AbstractFilter.call(this);

    this.passes = [this];
    
    color = color || [0, 0, 0, 0.5];

    this.uniforms = {
        color: {type: '4fv', value: color}
    };

    this.fragmentSrc = fragment;

};

SilohuetteColor.prototype = Object.create(PIXI.AbstractFilter.prototype);
SilohuetteColor.prototype.constructor = SilohuetteColor;

Object.defineProperties(SilohuetteColor.prototype, {
    color : {
        get: function() {
            return this.uniforms.color.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.color.value = value;
        }
    }
});


module.exports = SilohuetteColor;


/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/silohuetteColor.js
 **/